export const AI_USAGE_SOURCES = [
  "workflow_builder",
  "workflow_run",
  "autofix",
  "autotune",
  "personal_chat",
  "branch_name",
  "chat_name",
  "workflow_name",
  "step_test_name",
  "commit_message",
  // Recap generation was removed; the source survives so historical usage
  // records keep their label in monitoring.
  "chat_recap",
  "summarize",
  "context_recovery",
  "context_compaction",
  "workflow_value",
  "duplicate_detection",
] as const;

export type AiUsageSource = (typeof AI_USAGE_SOURCES)[number];

// Building a workflow, as opposed to running or monitoring it. Shared so the
// value endpoint's SQL filter and the monitoring UI's classifier can't drift.
export const BUILD_AI_USAGE_SOURCES = [
  "workflow_builder",
  "branch_name",
  "commit_message",
  "context_recovery",
  "context_compaction",
  "summarize",
  "chat_name",
  "workflow_name",
  "step_test_name",
  "chat_recap",
] as const satisfies readonly AiUsageSource[];
